{
  "Satışlar": "Satışlar",
  "satis": {
    "Satışlar": "Satışlar",
    "Satış Ekle": "Satış Ekle",
    "Satış Düzenle": "Satış Düzenle",
    "Tarih": "Tarih",
    "Müşteri": "Sigortalı",
    "Sigortalı": "Sigortalı",
    "Sigorta Ettiren": "Sigorta Ettiren",
    "Ürün": "Ürün",
    "Poliçe No": "Poliçe No",
    "Tutar (₺)": "Tutar (₺)",
    "Tutar ($)": "Tutar ($)",
    "Tutar": "Tutar",
    "Kur": "Kur",
    "Açıklama": "Not",
    "Durum": "Durum",
    "Ekle": "Ekle",
    "Filtrele": "Filtrele",
    "Data Yenile": "Data Yenile",
    "Onaysız": "Onaysız",
    "Onay": "Onay",
    "Cayma": "Cayma",
    "Not": "Not",
    "İptal": "İptal",
    "Bilinmiyor": "Bilinmiyor",
    "Kaydet": "Kaydet",
    "Güncelle": "Güncelle",
    "Filtreleri Temizle": "Filtreleri Temizle",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "İşlem": "İşlem",
    "Ara": "Ara",
    "Düzenle": "Düzenle",
    "Sil": "Sil",
    "Detay": "Detay",
    "Veriler yüklenemedi": "Veriler yüklenemedi",
    "Hata oluştu": "Hata oluştu",
    "Silme işlemi başarısız": "Silme işlemi başarısız",
    "Satış Tipi": "Satış Tipi",
    "Ödeme Şekli": "Ödeme Şekli",
    "Network": "Network",
    "Sağlık": "Sağlık",
    "Doğum": "Doğum",
    "Aktarım Tutar": "Aktarım Tutar (₺)",
    "Silme Onayı": "Silme Onayı",
    "Bu kaydı silmek istediğinize emin misiniz?": "Bu kaydı silmek istediğinize emin misiniz?"
  }
}
